<template>
  <section class="r-item-offer-page">
    <ac-data-table
      ref="table"
      :headers="headers"
      :items="items"
      :item-class="row_class"
      hide-default-footer
      disable-pagination
      sort-by="name"
      item-key="uid"
      fixed-header
      :height="winsize.height - 145"

      :search.sync="search"
      v-model="selected"

      :can-select="item => !row_readonly(item)"
      :can-delete="item => !row_readonly(item)"
      :remove-bulk="bulkRemove"
      :bulk-mode.sync="bulkMode"

      title="Item Offer"
    >
      <template #actions>
        <v-btn @click="row_create" class="ma-2" color="primary">
          New Item
        </v-btn>
        <v-btn @click="show_preview" class="ma-2" color="accent">
          Preview JSON
        </v-btn>
      </template>

      <template #bulk-extra>
        <v-btn
          x-small
          class="ma-2 white--text"
          color="blue"
          :disabled="!bulkMode || selected.length === 0"
          @click="bulkCopy"
        >
          Bulk Copy
          <span v-if="selected.length"> ({{ selected.length }})</span>
        </v-btn>
      </template>

      <template v-slot:item.price="{item}">
        <div align="center">
          <v-icon v-if="item.price.length>0">mdi-currency-usd</v-icon>
          <v-icon v-if="item.adPlacement">mdi-advertisements</v-icon>
        </div>
      </template>
      <template v-slot:item.enabled="{item}">
        <div align="center">{{ item.enabled ? "ON" : "OFF" }}</div>
      </template>
      <template v-slot:item.actions="{item}">
        <v-icon v-if="row_readonly(item)" @click="row_view(item)" class="mr-2" small color="green">
          mdi-eye
        </v-icon>
        <v-icon v-else-if="item.locked" @click="row_update(item)" class="mr-2" small color="orange">
          mdi-pencil
        </v-icon>
        <v-icon v-else @click="row_update(item)" class="mr-2" small color="green">
          mdi-pencil
        </v-icon>
        <v-icon @click="row_copy(item)" class="mr-2" small color="teal lighten-1">
          mdi-content-copy
        </v-icon>
        <v-icon :disabled="item.global || item.shared" @click="row_export(item)" class="mr-2" small color="blue">mdi-briefcase-upload</v-icon>
        <v-icon :disabled="row_readonly(item)" @click="row_remove(item)" class="mr-2" small color="red">
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:item.icon="{item}">
        <v-image-view style="width: 50px;height: 50px" :path="item_image(item)"/>
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="blue-grey" dense>
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
    </ac-data-table>

    <r-item-offer-dialog ref="dialog"/>
    <r-dialog-preview-collection ref="previewCollection"/>
    <r-bulk-copy-dialog ref="bulkCopyDialog"/>

    <v-overlay :value="bulkCopyLoading" z-index="999">
      <v-progress-circular indeterminate size="64"/>
    </v-overlay>
  </section>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {ItemOffer} from "@/modules/redactor/models/item-offer/ItemOffer";
import {serialize, deserialize} from "serializr";
import {uuid} from "vue-uuid";
import RItemOfferDialog from "@/modules/redactor/views/item-offer/r-item-offer-dialog";
import VImageView from "@/views/com/ImageView";
import AcDataTable from "@/components/Table/ac-data-table.vue";
import RDialogPreviewCollection from "@/modules/redactor/views/preview/r-preview-collection-dialog.vue";
import RBulkCopyDialog from "@/components/Dialog/r-bulk-copy-dialog.vue";

export default {
  components: {RDialogPreviewCollection, AcDataTable, VImageView, RItemOfferDialog, RBulkCopyDialog},
  data: () => ({
    search: "",
    headers: [
      {text: "Name", value: "name"},
      {text: "Item", value: "item.string"},
      {text: "Price", value: "price"},
      {text: "Icon", value: "icon", sortable: false},
      {text: "Status", value: "enabled"},
      {text: "UID", value: "uid"},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ],
    items: {
      type: VueTypes.arrayOf(ItemOffer)
    },
    selected: [],
    bulkMode: false,
    bulkCopyLoading: false,
  }),
  computed: {
    masterAccess() {
      return RedactorUtils.hasMasterAccess();
    },
    winsize() {
      return window.app.winsize;
    }
  },
  methods: {
    row_view(item) {
      this.$refs['dialog'].show(ViewRules.READONLY, item.clone()).catch(() => {

      });
    },
    row_copy(item) {
      this.$refs['dialog'].show(ViewRules.COPY, item.copy()).then(
          result => {
            RedactorUtils.pushItemOffer(result).then(
                () => {
                  this.$alert("Changes was published");
                });
          }, () => {
          });
    },
    row_create() {
      this.$refs['dialog'].show(ViewRules.CREATE, null).then(
          result => {
            RedactorUtils.pushItemOffer(result).then(
                () => {
                  this.$alert("Changes was published");
                });
          }, () => {
          });
    },
    row_update(item) {
      this.$refs['dialog'].show(ViewRules.UPDATE, item.clone()).then(
          result => {
            RedactorUtils.pushItemOffer(result).then(
                () => {
                  this.$alert("Changes was published");
                });
          }, () => {
          });
    },
    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        RedactorUtils.removeItemOffer(item).then(
            () => {
              this.$alert("Changes was published");
            });
      });
    },

    bulkRemove(items) {
      return RedactorUtils.removeBulkItemOffers(items);
    },

    async bulkCopy() {
      if (!this.selected || this.selected.length === 0) {
        this.$alert("No items selected");
        return;
      }

      try {
        const { search, replace } = await this.$refs['bulkCopyDialog'].show(this.selected.length);

        this.bulkCopyLoading = true;

        const copiedItems = [];
        const errors = [];
        let successCount = 0;

        const searchRegex = new RegExp(search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi');

        for (const item of this.selected) {
          try {
            const originalJson = serialize(ItemOffer, item);
            let jsonString = JSON.stringify(originalJson);
            jsonString = jsonString.replace(searchRegex, replace);
            searchRegex.lastIndex = 0;
            const modifiedJson = JSON.parse(jsonString);

            modifiedJson.uid = uuid.v4().replace(/-/g, "");
            modifiedJson.export = false;
            modifiedJson.global = false;

            const copiedItem = deserialize(ItemOffer, modifiedJson);

            if (!copiedItem) {
              errors.push(`Deserialization failed for ${item?.name || 'item offer'}.`);
              continue;
            }

            copiedItems.push(copiedItem);
            successCount++;
          } catch (error) {
            const itemName = item?.name || 'unknown item offer';
            errors.push(`Error copying ${itemName}: ${error.message}`);
          }
        }

        if (copiedItems.length > 0) {
          for (const copiedItem of copiedItems) {
            try {
              await RedactorUtils.pushItemOffer(copiedItem);
            } catch (pushError) {
              errors.push(`Error pushing ${copiedItem?.name || 'unknown'}: ${pushError.message}`);
            }
          }
        }

        let message = `Successfully copied ${successCount} item offer(s)`;
        if (errors.length > 0) {
          message += `\n\nErrors:\n${errors.join('\n')}`;
        }

        this.$alert(message, "Bulk Copy", errors.length > 0 ? "warning" : "success");

        this.selected = [];
        this.bulkMode = false;

      } catch (error) {
        if (error.message !== "Cancelled") {
          this.$alert(error.message, "Bulk Copy Error", "error");
        }
      } finally {
        this.bulkCopyLoading = false;
      }
    },

    row_export(item) {
      let result = item.clone();
      result.export = !item.export;
      RedactorUtils.pushItemOffer(result);
    },
    row_class(item) {
      if (item.shared) {
        return "yellow lighten-4"
      } else if (item.global) {
        return "cyan lighten-4"
      } else if (item.export) {
        return "green lighten-3"
      } else if (item.changed) {
        return "blue lighten-3"
      } else if (!item.enabled) {
        return "blue-grey lighten-3"
      }
    },


    item_image(item) {
      if (item && item.item) {
        return 'assets/items/' + item.item.value + '.png'
      } else {
        return "";
      }
    },
    row_readonly(item) {
      return (item.locked && !this.masterAccess) || item.global || item.shared;
    },
    show_preview() {
      this.$refs['previewCollection'].show(this.items, ItemOffer, "item-offer")
          .then(() => this.$alert("Changes was published"));
    },
  },
  created() {
    this.items = RedactorUtils.getItemOffers();
  }
};
</script>